module.exports = __webpack_public_path__ + "static/img/mast_91.2195c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mast_91.jpg
// module id = m+gb
// module chunks = 0